<footer class="footer-container">
    <p class="footer-text">United Rentals © All right reserved {{ getCurrentYear() }}</p>
</footer>